import { render, staticRenderFns } from "./ProfanityFilter.vue?vue&type=template&id=0c0f8f8e&"
import script from "./ProfanityFilter.vue?vue&type=script&lang=js&"
export * from "./ProfanityFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports